import React from "react";
import { Link } from "react-router-dom";
import { blogData } from "../Data/blogs";
import * as Unicons from "@iconscout/react-unicons";
import { Helmet } from "react-helmet";
import { websiteTitle } from "../helper/constants";

export default function Blogs() {
    return (
        <section
            className="relative md:py-24 py-16"
            id="blog"
        >
            <Helmet>
                <title>{websiteTitle}</title>
                <meta
                    name="description"
                    content="Explore our latest blog posts on various topics."
                />
            </Helmet>

            <div className="container">
                <div className="relative flex items-center justify-center pb-4">
                    <h3 className="mb-6 text-xl font-semibold leading-normal">
                        Blogs
                    </h3>
                    <Link to="/blogs" className="text-amber-500 hover:underline absolute right-0 pr-4 mb-6">
                        See All Blogs
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] mt-8">
                    {blogData.slice(0, 6).map((item, index) => (
                        <div
                            key={index}
                            className="blog relative rounded-lg shadow shadow-slate-200 dark:shadow-gray-800 overflow-hidden"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-48 object-cover rounded-lg"
                            />
                            <div className="content p-6">
                                <Link
                                    to={`/blogs/${item.slug}`}
                                    className="text-[17px] font-medium h5 hover:text-amber-500 dark:text-white dark:hover:text-amber-500 transition duration-500 ease-in-out block"
                                >
                                    {item.title}
                                </Link>
                                <p className="text-slate-400 mt-3 text-[15px]">  {item.desc.length > 75 ? item.desc.slice(0, 75) + "..." : item.desc}</p>

                                <div className="mt-5">
                                    <Link
                                        to={`/blogs/${item.slug}`}
                                        className="inline-flex items-center gap-1 text-sm hover:text-amber-500 dark:hover:text-amber-500 dark:text-white transition duration-500"
                                    >
                                        Read More <Unicons.UilArrowRight width={16} />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
